import { Box } from '@thirdspacelearning/library';

import { RedirectActionPanel } from '@shared';

const sx = {
    pageContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
    },
};

const NoMatch = () => {
    return (
        <Box sx={sx.pageContainer}>
            <RedirectActionPanel />
        </Box>
    );
};

export default NoMatch;
